import { apiSlice } from "../../app/api/apiSlice";

export const standardDocumentUploadFileForS3FallbackApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		standardDocumentUploadFileForS3Fallback: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/upload_attachment_for_s3_fallback/",
				method: "POST",
				body: credentials?.formData,
			}),
		}),
	}),
});

export const { useStandardDocumentUploadFileForS3FallbackMutation } =
	standardDocumentUploadFileForS3FallbackApiSlice;
